// import { createBrowserRouter } from "react-router-dom";
// import App from "../App";
// import Home from "../pages/Home";
// import Login from "../pages/Login";
// import ProfileForm from "../components/ProfileForm";
// import Address from "../pages/Address";
// import Product from "../pages/Product";
// import Collection from "../pages/Collection";
// import Wishlist from "../pages/Wishlist";
// import Checkout from "../pages/Checkout";
// import Order from "../pages/Order";
// import OrderDetail from "../pages/OrderDetail";
// import TermsAndConditions from "../pages/TermsAndConditions";
// import PrivacyPolicy from "../pages/PrivacyPolicy";
// import ShippingDelivery from "../pages/ShippingDelivery";
// import ReturnRefund from "../pages/ReturnRefund";
// import Disclaimer from "../pages/Disclaimer";
// import ContactUs from "../pages/ContactUs";
// import AboutUs from "../pages/AboutUs";
// import RateYourProduct from "../pages/RateYourProduct";
// import ProtectedRoute from "../components/ProtectedRoute";
// import ErrorPage from "../pages/ErrorPage"; // You'll create this file next
// import PaymentCallback from "../pages/PaymentCallback";
// import BlogDetail from "../components/BlogDetail";
// import Blog from "../pages/Blog";
// import DigitalCertificate from "../pages/DigitalCertificate";
// import WholesaleInquiry from "../components/WholesaleInquiry";

// const router = createBrowserRouter([
//     {
//         path: "/",
//         element: <App />,
//         children: [
//             {
//                 path: "",
//                 element: <Home />
//             },
//             {
//                 path: "/login",
//                 element: <Login />
//             },
//             {
//                 path: "/user/profile",
//                 element: <ProtectedRoute><ProfileForm /></ProtectedRoute>
//             },
//             {
//                 path: "/user/address",
//                 element: <ProtectedRoute><Address /></ProtectedRoute>
//             },
//             {
//                 path: "/product/:slugify_url",
//                 element: <Product />
//             },
//             // {
//             //     path: "/collection",
//             //     element: <Collection />
//             // },
//             {
//                 path: "/collections/*", // SEO-friendly URL
//                 element: <Collection />
//             },
//             {
//                 path: "/user/wishlist",
//                 element: <ProtectedRoute><Wishlist /></ProtectedRoute>
//             },  
//             {
//                 path: "/payment-callback",
//                 element: <PaymentCallback />
//             },         
//             {
//                 path: "/checkout",
//                 element: <ProtectedRoute><Checkout /></ProtectedRoute>
//             },
            
//             {
//                 path: "/user/order",
//                 element: <ProtectedRoute><Order /></ProtectedRoute>
//             },
//             {
//                 path: "/user/orderdetail",
//                 element: <ProtectedRoute><OrderDetail /></ProtectedRoute>
//             },
//             {
//                 path: "/terms-and-conditions",
//                 element: <TermsAndConditions />
//             },
//             {
//                 path: "/privacy-policy",
//                 element: <PrivacyPolicy />
//             },
//             {
//                 path: "/shipping-and-delivery",
//                 element: <ShippingDelivery />
//             },
//             {
//                 path: "/return-refund-policy",
//                 element: <ReturnRefund />
//             },
//             {
//                 path: "/disclaimer",
//                 element: <Disclaimer />
//             },
//             {
//                 path: "/contact-us",
//                 element: <ContactUs />
//             },
//             {
//                 path: "/about-us",
//                 element: <AboutUs />
//             },
//             {
//                 path: "/rateyourproduct",
//                 element: <RateYourProduct />
//             },
//             {
//                 path: "/blog",
//                 element: <Blog />
//             },
//             {
//                 path: "/digital/:identifier",
//                 element: <DigitalCertificate />
//             },
//             {
//                 path: "/blog/:slug",
//                 element: <BlogDetail />
//             },
//             {
//                 path: "/kantha-stitch-saree-manufacturer-wholesale",
//                 element: <WholesaleInquiry />
//             },
//             {
//                 path: "*", // 2. Catch-all for any URL that doesn't match above
//                 element: <ErrorPage /> 
//             },
//         ]
//     },
// ]);

// export default router;

import React, { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "../App";

// --- LAZY LOADED PAGES ---
// These are only downloaded when the user navigates to the route
const Home = lazy(() => import("../pages/Home"));
const Login = lazy(() => import("../pages/Login"));
const Product = lazy(() => import("../pages/Product"));
const Collection = lazy(() => import("../pages/Collection"));
const Wishlist = lazy(() => import("../pages/Wishlist"));
const Checkout = lazy(() => import("../pages/Checkout"));
const Order = lazy(() => import("../pages/Order"));
const OrderDetail = lazy(() => import("../pages/OrderDetail"));
const Blog = lazy(() => import("../pages/Blog"));
const BlogDetail = lazy(() => import("../components/BlogDetail"));

const GuestCheckout = lazy(() => import("../pages/GuestCheckout"));
// HEAVY COMPONENT: Contains Google Maps (Crucial to lazy load this!)
const DigitalCertificate = lazy(() => import("../pages/DigitalCertificate"));

// Policy & Static Pages
const TermsAndConditions = lazy(() => import("../pages/TermsAndConditions"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const ShippingDelivery = lazy(() => import("../pages/ShippingDelivery"));
const ReturnRefund = lazy(() => import("../pages/ReturnRefund"));
const Disclaimer = lazy(() => import("../pages/Disclaimer"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const RateYourProduct = lazy(() => import("../pages/RateYourProduct"));
const WholesaleInquiry = lazy(() => import("../components/WholesaleInquiry"));

// User & Auth Components
const ProfileForm = lazy(() => import("../components/ProfileForm"));
const Address = lazy(() => import("../pages/Address"));
const ProtectedRoute = lazy(() => import("../components/ProtectedRoute"));
const ErrorPage = lazy(() => import("../pages/ErrorPage"));
const PaymentCallback = lazy(() => import("../pages/PaymentCallback"));

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            { path: "", element: <Home /> },
            { path: "/login", element: <Login /> },
            { path: "/product/:slugify_url", element: <Product /> },
            { path: "/collections/*", element: <Collection /> },
            { path: "/payment-callback", element: <PaymentCallback /> },
            { path: "/terms-and-conditions", element: <TermsAndConditions /> },
            { path: "/privacy-policy", element: <PrivacyPolicy /> },
            { path: "/shipping-and-delivery", element: <ShippingDelivery /> },
            { path: "/return-refund-policy", element: <ReturnRefund /> },
            { path: "/disclaimer", element: <Disclaimer /> },
            { path: "/contact-us", element: <ContactUs /> },
            { path: "/about-us", element: <AboutUs /> },
            { path: "/rateyourproduct", element: <RateYourProduct /> },
            { path: "/blog", element: <Blog /> },
            { path: "/blog/:slug", element: <BlogDetail /> },
            { path: "/digital/:identifier", element: <DigitalCertificate /> },
            { path: "/kantha-stitch-saree-manufacturer-wholesale", element: <WholesaleInquiry /> },
            { path: "/guest-checkout", element: <GuestCheckout /> },
            
            // Protected User Routes
            { path: "/user/profile", element: <ProtectedRoute><ProfileForm /></ProtectedRoute> },
            { path: "/user/address", element: <ProtectedRoute><Address /></ProtectedRoute> },
            { path: "/user/wishlist", element: <ProtectedRoute><Wishlist /></ProtectedRoute> },
            { path: "/checkout", element: <ProtectedRoute><Checkout /></ProtectedRoute> },
            { path: "/user/order", element: <ProtectedRoute><Order /></ProtectedRoute> },
            { path: "/user/orderdetail", element: <ProtectedRoute><OrderDetail /></ProtectedRoute> },
            
            { path: "*", element: <ErrorPage /> },
        ]
    },
]);

export default router;